export const composeRowDataForPlayer = ( player, columns ) => ( {
    rank: -1,
    player: player.details,
    position: player.details.position,
    team: player.team.teamId,
    ...columns.reduce( ( prev, curr ) => ( {
        ...prev,
        [ curr.accessor ]: player.stats.totals[ curr.accessor ]
    } ), {} )
} );